import { REDUX_ACTIONS, GAME_ID } from 'a/directorsCut/data/constants';

const initState = {
  canvas: [],
  frameIndex: -1,
};

const dropZoneReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SAVE_FRAME_TO_HISTORY: {
      const canvas = [...state.canvas];
      canvas[payload.frameIndex] = payload.canvasData;
      return {
        ...state,
        canvas,
      };
    }

    case REDUX_ACTIONS.GOTO_HISTORY_ITEM:
      return {
        ...state,
        frameIndex: payload.frameIndex,
      };

    case REDUX_ACTIONS.QUIT_HISTORY:
      return {
        ...state,
        frameIndex: -1,
      };

    case REDUX_ACTIONS.INITIALIZE_ROUND:
    case REDUX_ACTIONS.ROUND_END:
      return {
        ...initState,
      };

    default:
      return state;
  }
};

export default dropZoneReducer;
